import { useEffect, useState } from 'react'
import { APP_VERSION, DOWNLOAD_URL, MANUAL_URL } from '../shared/site-config'
import Header from './components/Header'
import { getSession, logout, type Session } from './lib/auth'
import { navigate, useHashRoute } from './hooks/useHashRoute'
import GuidePage from './pages/GuidePage'
import HomePage from './pages/HomePage'
import KeywordToolPage from './pages/KeywordToolPage'
import LoginPage from './pages/LoginPage'
import ResourcesPage from './pages/ResourcesPage'

export default function App() {
  const route = useHashRoute()
  const [session, setSession] = useState<Session | null>(() => getSession())

  useEffect(() => {
    if (route === 'keyword-tool' && !session) navigate('login')
  }, [route, session])

  const handleLogout = () => {
    logout()
    setSession(null)
    navigate('home')
  }

  return (
    <div className="app-shell">
      <Header session={session} onLogout={handleLogout} />
      <main>
        {route === 'home' && <HomePage />}
        {route === 'resources' && <ResourcesPage />}
        {route === 'guide' && <GuidePage />}
        {route === 'login' && (
          <LoginPage
            onLogin={(nextSession) => {
              setSession(nextSession)
              navigate('keyword-tool')
            }}
          />
        )}
        {route === 'keyword-tool' && session && <KeywordToolPage />}
      </main>
      <footer className="site-footer">
        <div>
          <span>DSM Editor</span>
          <span>v{APP_VERSION}</span>
        </div>
        <nav aria-label="하단 메뉴">
          <a href={DOWNLOAD_URL}>프로그램 다운로드</a>
          <a href={MANUAL_URL} target="_blank" rel="noreferrer">사용 설명서</a>
          <button onClick={() => navigate('guide')}>운영 안내</button>
        </nav>
      </footer>
    </div>
  )
}
